export const normalizeChannel = (channel: string): string =>
  channel?.toLowerCase() === 'diy' ? 'DIY' : channel;

export const normalizeChannels = (channels: string[]): string[] =>
  channels.map(normalizeChannel);
